import { Accordion, Card, Heading, Row } from '@mlc/web-ui-toolkit';
import styled from 'styled-components';
import { mlcDove } from '@mlc/mlc-palette';
import { ScreenSize } from '../../../../enums';

export const SummaryRow = styled(Row)`
	@media (max-width: ${ScreenSize.small}) {
		flex-direction: column;

		div {
			border-left: 0;
			flex: 0 0 100%;
			max-width: 100%;

			p {
				padding-left: 10px;
			}
		}
	}
`;

export const TitleRow = styled(Row)`
	@media (max-width: ${ScreenSize.small}) {
		flex-direction: column;

		div {
			max-width: 100%;

			p {
				text-align: left;
			}

			:last-child {
				p {
					border-bottom: 1px solid ${mlcDove};
					margin-bottom: 0;
					padding-bottom: 30px;
				}
			}
		}
	}
`;

export const ResponsiveAccordion = styled(Accordion)`
	@media (min-width: ${ScreenSize.medium}) {
		.Accordion__icon {
			display: none;
		}
	}
`;

export const ResponsiveHeading = styled(Heading)`
	@media (max-width: ${ScreenSize.small}) {
		margin-bottom: 10px !important;
	}
`;

export const HeaderRow = styled(Row)`
	@media (max-width: ${ScreenSize.small}) {
		flex-direction: column;

		div {
			width: 100%;
		}
	}
`;

export const ProductCard = styled(Card)`
	@media (max-width: ${ScreenSize.small}) {
		border-left: none;

		p {
			padding-left: 0;
		}
	}
`;
